// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "pfx-CommunityMessageUser-module__btn--v4yPm";
var _7 = "pfx-CommunityMessageUser-module__btn-container--Ij9Qd";
var _8 = "pfx-CommunityMessageUser-module__container--GQZiK";
var _9 = "1140px";
var _a = "940px";
var _b = "100%";
var _c = "15px";
var _d = "620px";
var _e = "#f53535";
var _f = "rgba(0,0,0,.2)";
var _10 = "rgba(255,255,255,.38)";
var _11 = ".38";
var _12 = "rgba(255,255,255,.2)";
var _13 = "#0025ff";
var _14 = "pfx-CommunityMessageUser-module__glitch-anim--nPRoq";
var _15 = "pfx-CommunityMessageUser-module__glitch-anim-2--gD0yB";
var _16 = "#f60";
var _17 = "#41ead4";
var _18 = "#2cdd78";
var _19 = "#66ab23";
var _1a = "#f5f5f5";
var _1b = "#c3c3c3";
var _1c = "#ececec";
var _1d = "#252525";
var _1e = "#272727";
var _1f = "#c6c6c5";
var _20 = "#333";
var _21 = "#3c3c3c";
var _22 = "#9c9b9b";
var _23 = "#8c8c8c";
var _24 = "#6f6f6e";
var _25 = "#3c3c3b";
var _26 = "#373737";
var _27 = "#6a6a69";
var _28 = "#6f6f6f";
var _29 = "#9f9e9e";
var _2a = "#282828";
var _2b = "#828181";
var _2c = "#1d1d1d";
var _2d = "#979797";
var _2e = "#9c9b9b";
var _2f = "#a7a7a6";
var _30 = "#c6c6c5";
var _31 = "#d8d8d7";
var _32 = "#dddddc";
var _33 = "pfx-CommunityMessageUser-module__header--_uA6w";
var _34 = "72px";
var _35 = "40px";
var _36 = "36px";
var _37 = "25px";
var _38 = "18px";
var _39 = "13px";
var _3a = "#0025ff";
var _3b = "pfx-CommunityMessageUser-module__label--vYv6F";
var _3c = "rgba(255,255,255,.12)";
var _3d = "#6535f5";
var _3e = "2px";
var _3f = "56px";
var _40 = "56px";
var _41 = "#41ead4";
var _42 = "#f60";
var _43 = "#f83600";
var _44 = "#881f00";
var _45 = "18px";
var _46 = "15px";
var _47 = "pfx-CommunityMessageUser-module__pfx-icon--xOd2x";
var _48 = "red";
var _49 = "13px";
var _4a = "rgba(255,255,255,.07)";
var _4b = "pfx-CommunityMessageUser-module__success--gkWJZ";
var _4c = "pfx-CommunityMessageUser-module__success-icon--nwm5U";
var _4d = "pfx-CommunityMessageUser-module__textarea--PFTrj";
var _4e = "#35465c";
var _4f = "#55acee";
var _50 = "#fff";
var _51 = "#ffce36";
var _52 = "#ffcd00";
var _53 = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "btn", _7 as "btnContainer", _8 as "container", _9 as "containerLarge", _a as "containerMedium", _b as "containerMobile", _c as "containerPaddingMobile", _d as "containerSmall", _e as "danger", _f as "darkElement", _10 as "disabled", _11 as "disabledOpacity", _12 as "extraLightElement", _13 as "facebook", _14 as "glitchAnim", _15 as "glitchAnim2", _16 as "google", _17 as "green", _18 as "green2", _19 as "greenColor", _1a as "grey1", _1b as "grey10", _1c as "grey2", _1d as "grey25", _1e as "grey27", _1f as "grey3", _20 as "grey33", _21 as "grey3C", _22 as "grey4", _23 as "grey41", _24 as "grey5", _25 as "grey6", _26 as "grey61", _27 as "grey6A", _28 as "grey6F", _29 as "grey7", _2a as "grey8", _2b as "grey82", _2c as "grey9", _2d as "grey97", _2e as "grey9C", _2f as "greyA7", _30 as "greyC6", _31 as "greyD8", _32 as "greyDd", _33 as "header", _34 as "header1", _35 as "header2", _36 as "header3", _37 as "header4", _38 as "header5", _39 as "header6", _3a as "klein", _3b as "label", _3c as "lightElement", _3d as "lilac", _3e as "menuBorder", _3f as "menuHeight", _40 as "menuMobileHeight", _41 as "ocean", _42 as "orange", _43 as "orange2", _44 as "orangeDark", _45 as "paragraph", _46 as "paragraphSmall", _47 as "pfxIcon", _48 as "red", _49 as "subHeaderSmall", _4a as "subtleLightElement", _4b as "success", _4c as "successIcon", _4d as "textarea", _4e as "tumblr", _4f as "twitter", _50 as "white", _51 as "yellow", _52 as "yellowDeep", _53 as "youtube" }
